const sampleCsvData = [
  {
    unifiedNationalNumber: '7001272184',
    verificationType: 'BASIC',
    language: 'en',
  },
  {
    unifiedNationalNumber: '7001272184',
    verificationType: 'FULL',
    language: 'ar',
  },
];

const corporateSampleCsvFile = {
  fileName: 'corporate-verification-bulk-upload.csv',
  sampleCsvData,
};

export { corporateSampleCsvFile };

